<div>
    <app-header></app-header>
    <router-outlet></router-outlet>
    <a [@appearInOut]="animationState" href="https://wa.me/+918728001984" target="_blank">
        <img src="assets/images/logo/Whatsapp-logo-vector-png.png" class="md-raised md-primary" alt="whatsapp"
            id="myBtn">
    </a>
    <app-footer></app-footer>
</div>